// Role identifier for the restricted dashboard-only experience.
export const DASHBOARD_ONLY_ROLE = 'dashboard-only'

// Absolute route paths a dashboard-only user is permitted to access. All other
// application areas are off-limits and redirect back to the dashboard.
export const DASHBOARD_ONLY_ALLOWED_PATHS = [
  '/dashboard',
  '/mav-aero',
  '/mav-aero-docs',
  '/mav-aero-web-launcher',
  '/platform-docs',
  '/profile'
]

export const isDashboardOnlyRole = (roleId?: string | null): boolean =>
  (roleId || '').toLowerCase() === DASHBOARD_ONLY_ROLE

export const isPathAllowedForDashboardOnly = (pathname: string): boolean =>
  DASHBOARD_ONLY_ALLOWED_PATHS.some(
    allowed => pathname === allowed || pathname.startsWith(`${allowed}/`)
  )

// Role identifier for the read-only experience: users may view everything but
// cannot create, edit, delete, or submit anything.
export const READ_ONLY_ROLE = 'read-only'

export const isReadOnlyRole = (roleId?: string | null): boolean =>
  (roleId || '').toLowerCase() === READ_ONLY_ROLE

// Whether a role is permitted to mutate data (create/edit/delete/submit).
// Read-only users cannot; every other role can (subject to its own permissions).
export const canMutate = (roleId?: string | null): boolean => !isReadOnlyRole(roleId)
